export default "__VITE_ASSET__CJgWwtnN__"